













import Vue from "vue";

export default Vue.extend({
  name: "NthOrderAddBtn",

  props: {
    next: {
      type: Number,
      required: true
    }
  },

  methods: {
    addNthBtnClick(): void {
      this.$emit("addNthBtnClick");
    }
  }
});
